/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {
    CLEAR_ADDITIONAL_INFO,
    INIT_UPLOAD,
    RESOURCE_UPLOAD,
    RESOURCE_UPLOAD_SUCCESS_DATA_EDIT,
    VALIDATE_ADDITIONAL_INFO, GET_RESOURCE_SUCCESS, CLEAR_RESOURCE
} from '../_actions/resource.upload.actions';

export const INITIAL_STATE ={
    errorObj: {},
    isValid: false,
    successData: {}
};

export function uploadReducer(state = INITIAL_STATE, action){
    switch (action.type){
        case CLEAR_ADDITIONAL_INFO: {
            let objToClear = {...state.successData.cccSearchDTO};
            const successData = {...state.successData};
            if (action.payload !== undefined) {
                for (const key in action.payload) {
                    if (action.payload.hasOwnProperty(key)) {
                        delete objToClear[key];
                    }
                }
                successData.cccSearchDTO = objToClear;
                return {...state, successData: successData};
            } else {
                return {...state, successData: {}};
            }
        }
        case INIT_UPLOAD:
            return {...state, init: action.payload};
        case RESOURCE_UPLOAD: {
            const resourceData = {...state};
            resourceData.isUploaded = action.payload.isUploaded;
            resourceData.fileName = action.payload.fileName;
            resourceData.resourceId = action.payload.data.resourceId;
            return resourceData;
        }
        case RESOURCE_UPLOAD_SUCCESS_DATA_EDIT: {
            let successData = {...state.successData};
            let cccSearchDTO = {...successData.cccSearchDTO};
            cccSearchDTO[action.payload.key] = action.payload.value;
            successData.cccSearchDTO = cccSearchDTO;
            return {...state, successData};
        }
        case VALIDATE_ADDITIONAL_INFO: {
            const errorObj = {...state.errorObj};
            for (const key in action.payload) {
                errorObj[key] = action.payload[key];
            }
            return {...state, errorObj: errorObj};
        }
        case GET_RESOURCE_SUCCESS: {
            let successData = {...state.successData};
            successData = action.payload.data;
            return {...state, successData};
        }
        case CLEAR_RESOURCE: {
            return INITIAL_STATE;
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/resource.upload.reducer.js